import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import { useAnalytics } from '~/hooks/useAnalytics';
import { AnalyticsEvents } from '~/services/analytics';

const YOUTUBE_VIDEO_ID = 'Zy4Ve_-xCNI';

interface AiChatSellingVideoProps {
  title: string;
}

const AiChatSellingVideo: React.FC<AiChatSellingVideoProps> = ({ title }) => {
  const { track } = useAnalytics();

  return (
    <LiteYouTubeEmbed
      id={YOUTUBE_VIDEO_ID}
      title={title}
      params={{ rel: 0 }}
      enableJsApi
      stopOnEnd
      onIframeAdded={() => track(AnalyticsEvents.PERLA_PLAY_VIDEO_CLICKED)}
    />
  );
};

export default AiChatSellingVideo;
